import * as ResizablePrimitive from 'react-resizable-panels';

import { cn } from '~/lib/utils';

const ResizablePanelGroup = ({ className, ...props }: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
  <ResizablePrimitive.PanelGroup
    className={cn('flex h-full w-full data-[panel-group-direction=vertical]:flex-col', className)}
    {...props}
  />
);

const ResizablePanel = ResizablePrimitive.Panel;

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
}) => (
  <ResizablePrimitive.PanelResizeHandle
    className={cn(
      'group relative flex w-0 items-center justify-center bg-transparent focus-visible:outline-none z-10',
      'data-[panel-group-direction=vertical]:h-0 data-[panel-group-direction=vertical]:w-full',
      className,
    )}
    {...props}
  >
    {withHandle && (
      <div
        className={cn(
          'absolute inset-y-6 w-[2px] rounded-full z-10 -mx-2 px-2',
          'bg-transparent transition-all duration-200 ease-out',
          'group-hover:bg-muted-foreground/35',
          'group-active:bg-muted-foreground/60 group-active:w-[3px]',
          'data-[panel-group-direction=vertical]:inset-y-0 data-[panel-group-direction=vertical]:inset-x-6',
          'data-[panel-group-direction=vertical]:h-[2px] data-[panel-group-direction=vertical]:w-auto',
        )}
      />
    )}
  </ResizablePrimitive.PanelResizeHandle>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
